import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  MarkdownEditor,
} from '@duck/ui'
import { ChallengeService, TaskService } from '@duck/api-definitions'
import { useTar } from '@/modules'
import { TASK_PROFICIENCIES } from '@/utils/taskProficiencies'

interface TaskInfoDialogProps {
  task: ChallengeService.Task | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const TaskInfoDialog: React.FC<TaskInfoDialogProps> = ({
  task,
  open,
  onOpenChange,
}) => {
  const { t } = useTar()

  if (!task) {
    return null
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl flex flex-col">
        <DialogHeader className="flex flex-col items-center justify-between">
          <DialogTitle className="text-2xl">{task.name}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto space-y-4 mt-4">
          {/* Full Description (Markup) */}
          {(task.description) && (
            <div className="">
              <h3 className="text-sm font-semibold text-foreground mb-2">
                {t('challenges.taskDetails')}
              </h3>
              <div className="border border-border rounded-lg overflow-hidden bg-card">
                <MarkdownEditor
                  defaultValue={task.description || ''}
                  mode="view"
                  className="min-h-[200px] max-h-[400px]"
                  mdClassName="bg-background"
                />
              </div>
            </div>
          )}
          {/* Proficiencies */}
          {task.proficiencies && task.proficiencies.length > 0 && (
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-2">{t('challenges.skillsYouWillPractice')}</h3>
              <div className="flex flex-wrap flex-row justify-center gap-8 p-4 border border-border bg-background rounded-lg">
                {task.proficiencies.map((p: string) => {
                  const proficiencyData = TASK_PROFICIENCIES[p as TaskService.TaskProficienciesEnum]
                  return (
                    <div className="flex flex-col items-center gap-1.5" title={p}>
                      {proficiencyData?.icon('h-12 w-12')}
                      <span className="text-sm text-foreground capitalize">{t(proficiencyData?.label)}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

